<template>
    <div class="main">
        <van-loading size="26px" vertical type="spinner" color="#1989fa">获取中...</van-loading>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    import store from '@/store';
    import config from '@/config';

    export default {
        name: "GiveawayTake",
        data(){
            return{
                product_id:this.$route.params.pid,  //参数产品id
                openid:this.$store.getters.getLoginUser.openid, //当前购买客户的open_id
                client_uid:this.$store.getters.getLoginUser.id,
            }
        },
        methods:{
            ...mapActions([
                'GetGiveawayLink',
            ]),
            start_take(){
                let p={
                    'client_uid':this.client_uid,
                    'openid':this.openid,
                    'product_id':this.product_id
                };
                this.GetGiveawayLink(p).then(res=>{
                    if(res.status>0){
                        this.$Dialog.alert({message:res.msg}).then(()=>{
                            this.$router.push({name:'home'});
                        });
                    }else{
                        //请求成功
                        //goto领取链接
                        let url = res.responseObject;
                        console.log(url);
                        window.location.href = url;
                    }
                });
            }
        },
        mounted() {
            this.start_take();
        },
        beforeRouteEnter(to, from, next){
            let loginUser = store.getters.getLoginUser;
            if(loginUser&&loginUser.openid){
                next();
            }else{
                //未登录，则发起微信登录授权
                let code = to.query.code;
                let sales_uid=to.params.sales_uid;
                let mode=1; //从梅唐四季号中领
                if(code){
                    // console.log('----- 开始调用后台微信登录接口 ------');
                    store.dispatch('WeixinLogin',{code,sales_uid,mode}).then(res=>{
                        // console.log('返回对象',res);
                        if(res.status>0){
                            //登录失败
                            next(false);
                        }else{
                            //成功
                            next();
                        }
                    });
                }else{
                    //无code则表示是第一次进入本页，发起微信授权
                    // let redirect_uri=encodeURIComponent(config.weixin.redirect_dev); //debug
                    let redirect_uri = encodeURIComponent(window.location.href);
                    let appid=config.weixin.appid_mt;
                    let state=''; //'product-detail-sale/1004/1002'; //debug
                    let auth_url= 'https://open.weixin.qq.com/connect/oauth2/authorize?' +
                        'appid=' +appid+
                        '&redirect_uri=' +redirect_uri+
                        '&response_type=code&scope=snsapi_userinfo&' +
                        'state=' +state+
                        '#wechat_redirect';
                    // console.log('weixin auth url',auth_url);
                    window.location.href = auth_url;
                }
            }
        },
    }
</script>

<style lang="scss" scoped>
    .main{
        padding-top: 50px;
        text-align: center;
    }
</style>
